import createWrappedField from 'ddiForm/wrapped/createWrappedField'
import Search from '../../components/SalesOrderSearch'

export default createWrappedField({
  Component: Search,
  name: 'DDISalesOrderSearchMobile'
})
